var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"m 27.271186,4.2711864 -15,14.9999996 -6.9999996,-7 -4.99999996,5 11.99999956,12 20,-19.9999996 z"}})}
var staticRenderFns = []

export { render, staticRenderFns }